import React from 'react';
import { deleteInventory } from '../../backend-services';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

interface InventoryDeletePromptProps {
  setShowPrompt: (show: boolean) => void;
  inventoryId: string | undefined;
  fetchInventory?: () => Promise<void>;
}

const InventoryDeletePrompt = ({ setShowPrompt, inventoryId, fetchInventory }: InventoryDeletePromptProps) => {
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const navigate = useNavigate();

  const handleInventoryDelete = async (id: string | undefined) => {
    if (id) {
      setIsDeleting(true);
      try {
        const res = await deleteInventory(id);
        setIsDeleting(false);
        setShowPrompt(false);
        navigate('/inventories');
        if (fetchInventory) fetchInventory();
        toast.success('Inventory Deleted Successfully');
      } catch (error: any) {
        setErrorMessage('Unable to Delete Inventory.');
        setIsDeleting(false);
        if (error.expense && (error.expense.status === 400 || error.expense.status === 500)) {
          navigate('/error');
        }
      }
    }
  };

  return (
    <>
      <div className="h-screen">
        <div className="flex justify-center mt-[13px] ">
          <h1 className="">
            Are you sure you want to delete this Inventory?
            <br />
            <span>This action can not be undone. </span>
          </h1>
        </div>
        <div role="form" className="flex w-full gap-6 mt-8" onSubmit={(e) => e.preventDefault()}>
          <div className="w-1/2">
            <button
              onClick={() => setShowPrompt(false)}
              className="w-full rounded-[4px] h-[55px] bg-[#FFFFFF] text-[#044E97] font-semibold border border-blue-500"
            >
              Cancel
            </button>
          </div>
          <div className="w-1/2">
            <button
              onClick={() => handleInventoryDelete(inventoryId)}
              className="w-full rounded-[4px] h-[55px] bg-[#FB0303] text-white  font-semibold"
            >
              {isDeleting ? 'Deleting...' : 'Delete'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InventoryDeletePrompt;
